<template>
  <div>
    <el-dialog title="新增业务节点" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
      :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
      style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose"
      v-el-drag-dialog v-el-dialog-center>

      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>节点信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  序号:
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.seq" style="width: 10vw!important;"
                            clearable />
                </td>
                <th>
                  <em class="f-red">*</em>
                  节点名称:
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.processName" style="width: 10vw!important;"
                            clearable />
                </td>
                <th>
                  下级节点:
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.sonProcessName" style="width: 10vw!important;"
                            clearable />
                </td>
                <th>
                  <em class="f-red">*</em>
                  节点阶段:
                </th>
                <td>
                  <el-select v-model="formData.processPeriod" placeholder="请选择" style="width: 10vw!important;" clearable>
                    <el-option label="登记" :value="1" />
                    <el-option label="发布" :value="2" />
                    <el-option label="已派网点" :value="5" />
                    <el-option label="网点已接单" :value="6" />
                    <el-option label="已派师傅" :value="9" />
                    <el-option label="师傅已接单" :value="10" />
                    <el-option label="已出发" :value="13" />
                    <el-option label="已上门" :value="17" />
                    <el-option label="配件备货中" :value="18" />
                    <el-option label="完工暂存" :value="20" />
                    <el-option label="寄修待确认" :value="30" />
                    <el-option label="待寄件" :value="31" />
                    <el-option label="已寄待签收" :value="32" />
                    <el-option label="待检测" :value="34" />
                    <el-option label="待维修" :value="36" />
                    <el-option label="修好待发货" :value="37" />
                    <el-option label="客户待签收" :value="38" />
                    <el-option label="寄修已完成" :value="39" />
                    <el-option label="退换待确认" :value="40" />
                    <el-option label="旧件待退回" :value="41" />
                    <el-option label="旧件待签收" :value="42" />
                    <el-option label="旧件已签收" :value="43" />
                    <el-option label="好件待寄出" :value="44" />
                    <el-option label="好件已寄出" :value="45" />
                    <el-option label="客户待签收" :value="48" />
                    <el-option label="退换已完成" :value="49" />
                  </el-select>
                </td>
              </tr>
              <div style="height: 5px;"></div>
              <tr>
                <th>
                  节点要求说明:
                </th>
                <td>
                  <el-input type="textarea" style="width: 70.5vw!important;" autocomplete="off"
                            v-model="formData.processRemark" clearable />
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  节点表单字段:
                </th>
                <td>
                  <el-input :rows="6" type="textarea" style="width: 70.5vw!important;" autocomplete="off"
                            v-model="formData.jsonText" clearable />
                </td>
              </tr>
              <tr>
                <th>
                  子表单模板:
                </th>
                <td>
                  <el-input :rows="6" type="textarea" style="width: 70.5vw!important;" autocomplete="off"
                            v-model="formData.sonJsonText" clearable />
                </td>
              </tr>
              <div style="height: 5px;"></div>
              </tbody>
            </table>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
        <el-button type="primary" plain class="button-sty" @click="dialogClose">
          <i class="el-icon-close el-icon"></i>
          取 消
        </el-button>
        <el-button type="primary" @click="commitData" class="button-sty">
          <i class="el-icon-check el-icon"></i>
          确 定
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import api from "@/api/projectApi";

export default {
    name: 'saleConfigDialog',
    props: ['visiable', 'multi', 'param', 'sid', 'id'],
    mixins: [selectDialogMixins],
    components: {
      preconditionDialog,
      pager,
    },

    created() {
      this.initSetting()

      this.formData.serviceTypeId = this.sid
      if (this.id) {
        this.formData.id = this.id
        this.getData()
      }
    },

    data() {
      return {
        formData: {
          id: null,
          serviceTypeId: null,
          seq: null,  // 序号，string类型
          processName: null,  // 节点名称
          processRemark: null,  // 节点要求说明
          jsonText: null,  // 节点表单字段,以json格式保存
          sonJsonText: null,  // 子表单模板,以json格式保存
          sonProcessName: null,  // 下级节点,如果有分支下级时,以;号拼接
          processPeriod: 0,  // "节点阶段：1登记;2发布;5已派网点;6网点已接单;9已派师傅;10师傅已接单;13已出发;17已上门;18配件备货中;20完工暂存;
        },
        showDialog: true,
        falseValue: false,
      };
    },


    methods: {
      commitData() {
        let flag = true
        if (this.formData.id) {
          flag = false
        }
        this.$http({
          url: flag ? api.basServiceTypeProcess.addDataUrl : api.basServiceTypeProcess.updateDataUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$message.success(flag ? '添加成功' : '修改成功')
          this.dialogClose()
        })
      },

      getData() {
        this.$http({
          url: api.basServiceTypeProcess.getDataUrl,
          method: 'post',
          data: {id: this.id}
        }).then(res => {
          this.formData = res.data.data
        })
      },


    }
  };
</script>
<style lang="scss" scoped>
  #containt .table-detail tbody tr th[data-v-44d67368] {
    width: 6vw !important;
  }

  .papers {
    position: absolute;
    left: 292px;
    top: 0px;

    ::v-deep.el-upload-list .el-upload-list__item {
      display: inline-block;
      width: 147px !important;
      margin-right: 14px;
      border-radius: 2px;
      border-color: #e8e8e8;
      margin-top: 7px;
      margin-left: 15px;
      padding: 0px !important;
      background-color: #e1e1e1;
      height: 20px;
    }

  }

  .d-item {
    border: 1px solid #ededed;
  }

  .table-detail {
    padding-left: 35px;
    display: inline-block;
  }

  .table-detail tr {
    margin-bottom: 10px;
    display: inline-block;

    th {
      font-weight: 400;
      text-align: right;
      width: 10vw;
      font-size: 12px;
      position: relative;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);

    }

    // td{
    // 	display: inline-block;
    // 	width: 170px !important;
    // }
  }



  .title b {
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
    font-weight: 600;
    margin-right: 84px;
    vertical-align: middle;
    color: #00c4b3;
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    margin-left: 0px;
    margin-top: 8px;
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0 28px 28px 0;
  }

  .detail-wrap {
    background-color: #fff;
    padding: 5px;
  }



  ::v-deep .el-dialog {
    // height: 700px;
    overflow: hidden;
  }

  ::v-deep body .dialog-style {
    border-radius: 8px;
    -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
    // height: 700px;
    overflow: hidden;
  }

  /* 注意此处不能有scoped 否则样式无法生效 */
  .el-cascader-panel {
    .el-radio__inner {
      border: 0px;
      background: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background: none;
    }

    .el-radio {
      height: 100%;
      width: 150px;
      position: absolute;
      z-index: 10;
    }
  }

  .table_main {
    padding-top: 5px;
    padding-left: 5px;
    border: 1px solid #ededed;
    width: calc(100% - 215px);
    border-bottom: none;

    .el-pagination {
      padding: 2px;

    }
  }

  .left_tree {
    width: 205px;

    .title {
      text-align: left;
      width: 182px;
      padding: 7px 0 5px !important;
      font-size: 13px;
      color: rgba(58, 39, 39, 0.96);

      >span {
        position: relative;
        left: 4px;
        top: -3px;
      }
    }

    ::v-deep.el-tree-node__label {
      width: calc(100% - 32px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
    }
  }

  .tree_icon {
    background: #f0f3ff;
  }

  // 重新修改tree组件样式
  ::v-deep.tree-line {
    .el-tree-node {
      position: relative;
      padding-left: 0px;
    }

    .el-tree-node__content {
      margin-top: 0px;
    }

    .el-tree-node__children {
      padding-left: 16px;
    }

    .el-tree-node::before {
      content: '';
      height: 100%;
      width: 1px;
      position: absolute;
      left: -3px;
      top: -26px;
      border-width: 1px;
      border-left: 1px dashed #d9d9d9;
    }

    .el-tree-node:last-child::before {
      height: 38px;
    }

    .el-tree-node::after {
      content: '';
      width: 24px;
      height: 1px;
      position: absolute;
      left: -3px;
      top: 12px;
      border-width: 1px;
      border-top: 1px dashed #d9d9d9;
    }

    &>.el-tree-node::after {
      border-top: none;
    }

    &>.el-tree-node::before {
      border-left: none;
    }

    .el-tree-node__expand-icon {
      font-size: 17px;

      // color: #000;
      &.is-leaf {
        color: transparent;
        // display: none;
      }
    }
  }
</style>
